import { Box } from "@mui/material";
import React from "react";
import CustomizerCart from "../CustomizerCart";
import GradientButton from "../gradients/GradientButton";
import BaseModal from "./BaseModal";
import BaseDrawer from "./mobile/BaseDrawer";
import { useData } from "../../providers/DataProvider";

export const CartModal = ({
  onClose,
  currentCart,
  previousCart,
  setPreviousCartLineItems,
  handleRemovePatchPoints,
  handleRemoveShopifyCartItem,
  handleCreateCheckout,
  lastIncompleteCheckout,
  isMobile,
}) => {
  const { setLoading } = useData();

  const Modal = isMobile ? BaseDrawer : BaseModal;

  return (
    <Modal headline="" onClose={onClose} modalWidth="800px">
      <CustomizerCart
        currentCart={currentCart}
        previousCart={previousCart}
        setPreviousCartLineItems={setPreviousCartLineItems}
        handleRemovePatchPoints={handleRemovePatchPoints}
        handleRemoveShopifyCartItem={handleRemoveShopifyCartItem}
        setLoading={setLoading}
        lastIncompleteCheckout={lastIncompleteCheckout}
        handleCreateCheckout={handleCreateCheckout}
      />
      {lastIncompleteCheckout && !!previousCart.length && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <GradientButton
            addStyle={isMobile ? { minHeight: "45px", fontSize: "15px" } : {}}
            onClick={() => {
              setLoading(true);
              window.location.assign(lastIncompleteCheckout.webUrl);
            }}
          >
            {isMobile ? "Use Previous Designs" : " Checkout with Previous Designs Only"}
          </GradientButton>
        </Box>
      )}
    </Modal>
  );
};

export default CartModal;
